/**
 * Advertisement configuration utilities and hooks
 */

import { useState } from 'react';

export interface AdConfig {
  enabled: boolean;
  frequency: number; // Show ad after every N items
  footerEnabled: boolean;
  mobileOnly: boolean;
}

// Default ad configuration
export const defaultAdConfig: AdConfig = {
  enabled: false, // Disabled until we have actual sponsors
  frequency: 10,
  footerEnabled: true,
  mobileOnly: true,
};

/**
 * Hook to manage ad configuration
 */
export const useAdConfig = (initialConfig: Partial<AdConfig> = {}) => {
  const [config, setConfig] = useState<AdConfig>({
    ...defaultAdConfig,
    ...initialConfig,
  });

  const updateConfig = (updates: Partial<AdConfig>) => {
    setConfig(prev => ({ ...prev, ...updates }));
  };

  return { config, updateConfig };
};
